export default __webpack_public_path__ + "static/media/google-analytics-gris.8442cfe9.png";